import { observer } from "mobx-react-lite";
import { ReactElement, useMemo, useState, type ReactNode } from "react";

import { CustomModel } from "../types";

import { useCustomModelsTable } from "./hooks/useCustomModelsTable";

import { DataTable } from "@/components/ui/ag-grid-table";
import { useDataTableDeleteConfirm } from "@/hooks/useDataTableDeleteConfirm";

export const CustomModelsTable = observer(
  ({
    onEditModel,
    models,
    action,
  }: {
    onEditModel: (model: CustomModel, isViewing?: boolean) => void;
    models: CustomModel[];
    action?: ReactNode;
  }) => {
    const onRequestDeleteConfirm = useDataTableDeleteConfirm();
    const [search, setSearch] = useState("");
    const { columns, contextMenuItems, actions, isDeletingModel, onDeleteModel } =
      useCustomModelsTable({
        onEditModel,
      });

    const filteredModels = useMemo(
      () =>
        models.filter(model => model.display_name?.toLowerCase().includes(search.toLowerCase())),
      [models, search],
    );

    return (
      <DataTable<CustomModel>
        data={filteredModels as CustomModel[]}
        hasSearch
        search={search}
        setSearch={setSearch}
        actions={actions}
        rowsDeletable
        isLoading={isDeletingModel}
        onRequestDeleteConfirm={onRequestDeleteConfirm}
        onDelete={model => onDeleteModel(model!)}
        objectName="model"
        columns={columns}
        onRowClick={model => onEditModel(model)}
        contextMenuItems={contextMenuItems}
        emptyStateMessage="No custom models found"
        action={action as ReactElement}
      />
    );
  },
);
